module.exports = __webpack_public_path__ + "img/four-enabled-big.1078d390.svg";